import { get } from 'lodash';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState as requestInitialState,
} from '../../utils/redux';

const paginatedRequest = {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'assignment_results',
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
  ],
};

const request = {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'assignment_results',
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
  ],
};

const initialState = {
  ...requestInitialState,
  pagination: {
    offset: 0,
    limit: 10,
  },
};

export const consts = createReqConsts('surveys', 'answered');
export const paginatedConsts = createReqConsts('surveys', 'answeredPaginated', [
  'LOAD_NEXT_REQUESTS',
  'UPDATE_PAGINATION_PARAMETERS',
]);

export const actions = createActions(consts);
export const paginatedActions = createActions(paginatedConsts);

export const watcher = createReqWatcher(consts, actions, request);
export const paginatedWatcher = createReqWatcher(
  paginatedConsts,
  paginatedActions,
  paginatedRequest,
);

const requestReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case consts.SUCCEED: {
      return Object.assign(
        {},
        state,
        requestInitialState,
        {
          succeed: true,
        },
        { list: payload },
      );
    }
    case paginatedConsts.SUCCEED: {
      const prevList = get(state, 'list', []);
      return Object.assign({}, state, requestInitialState, {
        succeed: true,
        list: prevList.concat(payload),
      });
    }

    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/surveys/answered.js